<script lang="ts" setup>
import { getCurrentInstance, computed } from 'vue';

defineOptions({
    name: 'field-textarea'
});

const props = defineProps({
  "label": null,
  "modelValue": null,
  "placeholder": null,
  "rows": null
});

const emit = defineEmits(["update:modelValue"]);

const instance = getCurrentInstance();

const uid = computed(() => `form-field-${instance.uid}`);

const update = (e: any): void =>
{
    emit('update:modelValue', e?.target?.value);
};
</script>

<template>
    <div class="form-group">
        <label :for="uid">{{ props.label }}</label>
        <textarea :id="uid" class="form-control" :placeholder="props.placeholder" :value="props.modelValue" :rows="props.rows" @input="update"></textarea>
    </div>
</template>
